// https://github.com/chakra-ui/chakra-ui/blob/main/packages/theme/src/components/table.ts

const Table = {
  parts: ["container", "label", "closeButton"],
  baseStyle: {
    table: {
      fontVariantNumeric: "lining-nums tabular-nums",
      borderCollapse: "collapse",
      width: "full",
    },
    th: {
      fontFamily: "body",
      fontWeight: "normal",
      textTransform: "none",
      letterSpacing: "normal",
      textAlign: "start",
      borderBottom: "",
      borderBottomWidth: "0px",
    },
    td: {
      textAlign: "start",
    },
    caption: {
      mt: 4,
      fontFamily: "heading",
      textAlign: "center",
      fontWeight: "medium",
    },
  },

}

export default Table
